<template>
  <div class="page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card min-height">
            <TableLoading v-if="unauthenticatedOrder.publicId === ''"/>
            <div v-else class="card-body">
              <div class="invoice-title">
                <h4 class="float-end font-size-16">Invoice # {{unauthenticatedOrder.invoiceId}}</h4>
                <div class="mb-4">
                  <img
                      src="@/assets/images/KikkomanNameLogo.png"
                      alt="logo"
                      height="20"
                  />
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong>From:</strong>
                    <p><br />Kikkoman East Africa <br/> 3F Roshanmaer Place<br/> Lenana Road Kilimani  <br/></p>
                    Pin P051667186Z <br/>
                    P.O BOX 52781-00100 <br/>Tel: 0790 366 564 or Tel: 0740 949 997 (CS)<br/>Tel: 0110 111 999 (Office)
                    <br />
                  </address>
                </div>
                <div class="col-6 text-sm-end">
                  <address >
                    <strong>Details:</strong>
                    <br />Delivery Date: {{unauthenticatedOrder.deliveryDate}}
                  </address>
                  <address class="mt-5">
                    <strong>Deliver To:</strong>
                    <br /><strong>{{unauthenticatedOrder.customer.name}}</strong>
                    <br />Tel. Number: 
                    <span v-if="unauthenticatedOrder.customer.phoneNumber"> {{ unauthenticatedOrder.customer.phoneNumber }} </span>
                    <span v-else> {{ unauthenticatedOrder.customer.institutionId.phoneNumber }} </span>
                    <br />Physical Address: {{ unauthenticatedOrder.customer.street }}
                  </address>
                </div>
              </div>
              <div class="p-2 mt-3">
                <h3 class="font-size-16">Order Summary</h3>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-light">
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product Name</th>
                    <th>Product Code</th>
                    <th class="text-sm-end">Quantity</th>
                  </tr>
                  </thead>
                  <tbody v-for="(item, index) in unauthenticatedOrder.orderItems" :key="item.publicId">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{item.item.productName}}</td>
                    <td>
                      {{item.item.code}}
                    </td>
                    <td class="text-sm-end">{{item.itemCount}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config.json";
import {SINGLE_WAREHOUSE_ORDER} from "@/gql/orders";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Warehouse Order Detail",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading},
  name: "order-details",
  data() {
    return {
      unauthenticatedOrder: {
        publicId: '',
        invoiceId: "",
        lpo: "",
        deliveryDate: "",
        customer: {
          street: "",
          institutionId: {
            name: "",
            postalCode: "",
            phoneNumber: "",
          }
        },
        orderItems: [{
          item: {
            productName: "",
            code: "",
            qpoUnit:""
          },
          itemCount: "",
          shipments: [{
            orderId : "",
          }]
        }]
      }
    }
  },
  apollo: {
    unauthenticatedOrder: {
      query: SINGLE_WAREHOUSE_ORDER,
      variables(){
        return {
          id: this.$route.params.id,
          authToken: this.$route.params.authToken
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
